$(document).ready(function () {
  $(document).on('click', '.portlet-head .closet,.closet', function () {
    $('.app-sidebar-overlay').removeClass('open');
    $('.app-sidebar').removeClass('open');
    $('body').removeClass('app-body');
  })
  $(document).on('click', '.recurring-btn', function () {
    $(this).parents('.app-sidebar').find('.recurring-data').slideToggle();
  });
  $(document).on('click', "input[name$='BookingMode']", function () {
    var test = $(this).val();
    $("div.mode").hide();
    $(".modes" + test).show();
  });
  $(document).on('click', ".time-btn", function () {
    // $(this).parents('.app-sidebar') .find('.time-data').slideToggle();
    $(this).parents('.app-sidebar').find('.time-data').show()
  });
  $(document).on('click', "a.time-btn-hide", function () {
    $(this).parents('.app-sidebar').find('.time-data').hide()
  });
  $(document).on('click', ".attendees", function () {
    $('.list-unstyled.sub-menu').toggleClass('hide');
  });
  $(document).on('click', ".menu-toggler", function () {
    $('header').toggleClass('open');      
    $('body').toggleClass('menu-toggler-body'); 
  });
  $(document).on('click', ".menu-toggler-body", function(){
    $('header').removeClass('open');      
    $('body').removeClass('menu-toggler-body'); 
  })
})



// WEBPACK FOOTER //
// src/assets/layouts/js/custom-app.js